import { ApiResourceFactory } from '../api.resource.factory'
import { LoginModel, UserModel } from '../api.models'
import { Permissions } from '../../../helpers/permissions'
import { CommonHelper } from  '../../../helpers/common-helper'

export interface ILoginService {
    login(loginModel: LoginModel): ng.IPromise<UserModel>
    logout(): ng.IPromise<boolean>
    getToken(): string
    getUser(): UserModel
    isLogged(): boolean
}

export class LoginService implements ILoginService {
    private user = null
    constructor(private apiResource: ApiResourceFactory) {
        
    }

    public login(loginModel: LoginModel): ng.IPromise<UserModel> {
        return this.apiResource.login.save(loginModel).$promise
            .then(data => {
                if (data.permissions) Permissions.setPermissions(data.permissions)
                data.avatar = data.avatar ? "data:image/png;base64," + data.avatar : null
                this.user = data
                return data
            })
    }

    public logout(): ng.IPromise<boolean> {
        return this.apiResource.login.delete().$promise
            .then(result => {
                Permissions.refresh()
                CommonHelper.removeValueFromLocalStorage('USER')
                this.user = null
                return true
            })
    }

    public getToken(): string {
        var user = this.getUser()
        return user ? user.token : ''
    }

    public getUser(): UserModel {
        if (!this.user)
            this.user = CommonHelper.getValueFromLocalStorage('USER')
        return this.user
    }

    public isLogged(): boolean {
        var user = this.getUser()
        return user != null && user.name != ''
    }
}
